export interface DeviceSignals {
  timezone: string;
  language: string;
  screen_w: number;
  screen_h: number;
  platform: string;
}

export function collectDeviceSignals(): DeviceSignals {
  return {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    screen_w: window.screen.width,
    screen_h: window.screen.height,
    platform: navigator.platform,
  };
}
